import React, { useEffect, useState } from 'react';

const COOKIE_CONSENT_KEY = 'cookie_consent_accepted';

const CookieConsent: React.FC = () => {
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        const consent = localStorage.getItem(COOKIE_CONSENT_KEY);
        if (!consent) {
            setIsVisible(true);
        }
    }, []);

    const handleAccept = () => {
        localStorage.setItem(COOKIE_CONSENT_KEY, 'true');
        setIsVisible(false);
    };

    if (!isVisible) return null;

    return (
        <div className="fixed bottom-0 rounded-tr-md bg-light-yellow drop-shadow text-black p-4 flex flex-col md:flex-row items-end md:items-center justify-between z-50 text-center md:text-left">
            <p className="text-sm mb-2 sm:mb-0 sm:mr-4">
                Este site usa cookies para melhorar sua experiência. Ao continuar, você concorda com nossa <a href="/politica-de-privacidade" className='font-semibold'>política de cookies.</a>
            </p>

            <button onClick={handleAccept} className="bg-main-pink hover:bg-main-blue text-white px-4 py-2 rounded transition-all duration-200">
                Aceitar
            </button>
        </div>
    );
};

export default CookieConsent;
